import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from '@core/services/account.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(public accountService: AccountService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      headers: request.headers.set('authorization', `Bearer ${this.accountService.getToken()}`)
    });

    return next.handle(request);
  }
}
